import React, { FunctionComponent, useState } from 'react';
import {
  IconButton,
  Menu,
  Card,
  CardContent,
  CardActions,
} from '@mui/material';
import { Check, Clear } from '@mui/icons-material';
import {useStyles} from './ReportStateFilterMenu.styles';
import { Select } from '../../../../components';
import { Constants } from '../../../../utils';

const { US_STATES } = Constants;

type Props = {
  anchorEl: Element | null;
  filterName: string;
  currentFilterValue: string | undefined;
  onClose: () => void;
  onApplyFilter: (filterName: string, filterValue: string | undefined) => void;
  onClearFilter: (filterName: string) => void;
};

const ReportStateFilterMenu: FunctionComponent<Props> = ({
  anchorEl,
  filterName,
  currentFilterValue,
  onClose,
  onApplyFilter,
  onClearFilter,
}) => {
  const classes = useStyles();
  const [filterValue, setFilterValue] = useState<string | undefined>(currentFilterValue);

  const onClearFilterButtonClick = () => {
    setFilterValue('');
    onClearFilter(filterName);
  };

  const onSubmit = (e: React.FormEvent) => {
    onApplyFilter(filterName, filterValue);
    e.preventDefault();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      className={classes.root}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
      <Card>
        <CardContent>
          <form noValidate autoComplete="off" onSubmit={onSubmit}>
            <Select
              id="site_location"
              name="site_location"
              labelText="Select Site State Location"
              placeholder="- Select State -"
              options={US_STATES}
              value={filterValue}
              onChange={(e) => { setFilterValue(e.target.value as string) }}
            />
          </form>
        </CardContent>
        <CardActions>
          <IconButton
            size='small'
            className={classes.applyFilterBtn}
            onClick={() => onApplyFilter(filterName, filterValue)}>
            <Check />
          </IconButton>
          <IconButton size="small" onClick={onClearFilterButtonClick}>
            <Clear />
          </IconButton>
        </CardActions>
      </Card>
    </Menu>
  );
};

export default ReportStateFilterMenu;